import React from 'react'

import { Input } from 'ui/components/Input'

export const StringDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
}> = ({ value, onChange }) => {
    return (
        <Input
            type="text"
            placeholder="Enter default value"
            value={value?.value ?? ''}
            onChange={(e) => onChange({ type: 'constant', value: e.target.value })}
        />
    )
}
